// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__YIcP6","wrapper":"PriceList_wrapper__WKg66","pricing":"PriceList_pricing__+KWdD","footerStyle":"PriceList_footerStyle__C8yQU"};